import * as React from 'react';
import { observer } from 'mobx-react';
import { classes } from '../../utils/Classes';
import { Shade } from '../../domain/entities/Shade';
import styled from 'styled-components';
import { Subtitle3 } from 'elc-typography';

interface IProductShadeDescriptionProps {
    shade?: Shade;
    position?: string;
}

interface IColorTitleProps {
    color?: string;
}

const ColorTitle = styled(Subtitle3)`
    color: ${({ color }: IColorTitleProps) => color};
`;

export const ProductShadeDescription = observer((props: IProductShadeDescriptionProps) => {
    const { shade, position } = props;
    const shadeDescriptionClassNames = classes(`shade-description-${position}`);
    const shadeDescriptionColor = (shade && shade.hexVal) || (shade && shade.colors[0]);
    const shadeDescription = shade && shade.description;

    return shadeDescription ? (
        <ColorTitle color={shadeDescriptionColor} className={shadeDescriptionClassNames}>
            {shadeDescription}
        </ColorTitle>
    ) : null;
});
